import styles from './index.module.css'

import React from 'react'
import { RiDraggable } from '@react-icons/all-files/ri/RiDraggable'

type TrackNumberDragHandleProps = {
  index: number
}

const TrackNumberDragHandle = ({ index }: TrackNumberDragHandleProps) => {
  return (
    <div className={styles.container} data-track-number-drag-handle>
      <span className={styles.trackNumber} data-track-number>
        {index + 1}
      </span>
      <RiDraggable
        className={styles.dragIcon}
        data-drag-icon
        aria-hidden="true"
      />
    </div>
  )
}

export default TrackNumberDragHandle
